import { Box } from '@mui/material';
import React from 'react';

type GridColumnsProps = {
  columns: number;
  children: React.ReactNode;
};

export const GRID_WIDTH = 145;

export const GridColumns = React.forwardRef<HTMLDivElement, GridColumnsProps>(
  ({ children, columns }, ref) => (
    <Box
      id="grid-ref"
      ref={ref}
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gap: '.75rem',
        gridTemplateColumns: `repeat(${columns}, minmax(${GRID_WIDTH}px, 1fr))`,
      }}
    >
      {children}
    </Box>
  ),
);
